<div class="row">
  <div class="col-12">
    <div class="d-flex flex-column flex-lg-row">
      <div class="d-flex flex-column align-items-center align-items-lg-start">
        <div
          class="gb-body1 heavy"
          [translate]="'chat_footer_assistance_header'"
        ></div>
        <div
          class="gb-body1 mb-5"
          [innerHTML]="'chat_footer_assistance_subheader' | translate"
        ></div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-3" *ngIf="(showMessageUsBtn | async) === 'true'">
    <button
      id="chatFooterMessageUs"
      class="gb-secondary-button-inline-icon icon-left"
      (click)="openChat(); trackingService.fireProp10Tracking(trackingString??'shop:update plan:button:chat','','','chat','' ,true)"
      [attr.aria-label]="'messageUs_footer_label' | translate"
    >
      <span class="icon-ui-chat mr-2"></span>
      <span [translate]="'chat_footer_messageUs_button'"></span>
    </button>
  </div>
</div>
